import React, { SVGProps } from 'react';

export const ClearIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      {...props}
    >
      <path
        fill="currentColor"
        d="M10 1.669a8.336 8.336 0 0 0-8.333 8.333c0 4.6 3.733 8.334 8.333 8.334s8.333-3.734 8.333-8.334S14.6 1.67 10 1.67Zm2.942 10.392a.629.629 0 0 1 0 .883.618.618 0 0 1-.442.183.618.618 0 0 1-.442-.183L10 10.886l-2.058 2.058a.618.618 0 0 1-.442.183.618.618 0 0 1-.442-.183.629.629 0 0 1 0-.883l2.059-2.059-2.059-2.058a.629.629 0 0 1 0-.883.629.629 0 0 1 .884 0L10 9.119l2.058-2.058a.629.629 0 0 1 .884 0 .629.629 0 0 1 0 .883l-2.059 2.058 2.059 2.059Z"
      />
    </svg>
  );
};
